// @ts-check

import SSNField from '@/components/fields/SSNField.vue'

export const aliases = {
  SSNField
}

export const defaults = {
  /** @type {import('vuetify/components/VTextField').VTextField['$props']} */
  VTextField: {
    variant: 'outlined',
    color: 'primary',
    bgColor: 'white',
    density: 'compact',
    hideDetails: 'auto',
    persistentPlaceholder: true,
    persistentHint: true,
    rounded: 'md'
  },
  /** @type {import('vuetify/components/VNumberInput').VNumberInput['$props']} */
  VNumberInput: {
    variant: 'outlined',
    color: 'primary',
    bgColor: 'white',
    density: 'compact',
    hideDetails: 'auto',
    persistentPlaceholder: true,
    persistentHint: true,
    rounded: 'md',
    controlVariant: 'stacked'
  },
  /** @type {import('vuetify/components/VCombobox').VCombobox['$props']} */
  VCombobox: {
    variant: 'outlined',
    color: 'primary',
    bgColor: 'white',
    density: 'compact',
    hideDetails: 'auto',
    persistentPlaceholder: true,
    persistentHint: true,
    rounded: 'md',
    listProps: {
      density: 'compact'
    },
    menuIcon: '$chevron-down'
  },
  /** @type {import('vuetify/components/VAutocomplete').VAutocomplete['$props']} */
  VAutocomplete: {
    variant: 'outlined',
    color: 'primary',
    bgColor: 'white',
    density: 'compact',
    hideDetails: 'auto',
    persistentPlaceholder: true,
    persistentHint: true,
    rounded: 'md',
    listProps: {
      density: 'compact'
    },
    menuIcon: '$chevron-down',
    menuProps: {
      maxWidth: 0
    },
    /** @type {import('vuetify/components/VList').VListItemTitle['$props']} */
    // @ts-expect-error - Vuetify component type doesn't match exact usage
    VListItemTitle: {
      class: 'whitespace-normal'
    }
  },
  /** @type {import('vuetify/components/VTextarea').VTextarea['$props']} */
  VTextarea: {
    variant: 'outlined',
    color: 'primary',
    bgColor: 'white',
    density: 'compact',
    hideDetails: 'auto',
    persistentPlaceholder: true,
    persistentHint: true,
    persistentCounter: true,
    rounded: 'md'
  },
  /** @type {import('vuetify/components/VCheckbox').VCheckbox['$props']} */
  VCheckbox: {
    color: 'primary',
    hideDetails: 'auto',
    density: 'comfortable',
    baseColor: 'secondary-400'
  },
  /** @type {import('vuetify/components/VSelect').VSelect['$props']} */
  VSelect: {
    variant: 'outlined',
    color: 'primary',
    bgColor: 'white',
    density: 'compact',
    menuIcon: '$chevron-down',
    hideDetails: 'auto',
    persistentPlaceholder: true,
    persistentHint: true,
    listProps: {
      density: 'compact'
    },
    rounded: 'md'
  },
  /** @type {import('vuetify/components/VSwitch').VSwitch['$props']} */
  VSwitch: {
    color: 'primary',
    inset: true,
    hideDetails: 'auto',
    density: 'compact',
    baseColor: 'secondary-400'
  },
  /** @type {import('vuetify/labs/VDateInput').VDateInput['$props']} */
  VDateInput: {
    color: 'primary',
    bgColor: 'white',
    density: 'compact',
    hideDetails: 'auto',
    persistentPlaceholder: true,
    persistentHint: true,
    rounded: 'md',
    firstDayOfWeek: 1,
    hideHeader: true,
    showAdjacentMonths: true,
    modeIcon: '$chevron-down',
    variant: 'outlined',
    hideActions: true,
    prependIcon: '',
    appendInnerIcon: '$calendar-blank-outline'
  }
}
